var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3384.5 2077.9",
    style: {
      enableBackground: "new 0 0 3384.5 2077.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1434CB;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1461.3,739.8l-251.4,599.7h-164L922.2,861c-7.5-29.5-14-40.3-36.9-52.7c-37.3-20.2-98.9-39.2-153-51l3.7-17.4 h264c33.6,0,63.9,22.4,71.5,61.2l65.3,347l161.5-408.2L1461.3,739.8L1461.3,739.8z M2103.8,1143.8c0.7-158.3-218.9-167-217.4-237.7 c0.5-21.5,21-44.4,65.8-50.2c22.2-2.9,83.5-5.1,152.9,26.8l27.2-127.2c-37.3-13.5-85.4-26.6-145.1-26.6 c-153.3,0-261.3,81.5-262.2,198.2c-1,86.3,77,134.5,135.8,163.2c60.5,29.4,80.8,48.3,80.5,74.5c-0.4,40.2-48.2,58-92.9,58.7 c-78,1.2-123.2-21.1-159.3-37.9l-28.1,131.4c36.2,16.6,103.2,31.1,172.5,31.9C1996.7,1349,2103.3,1268.4,2103.8,1143.8  M2508.8,1339.6h143.5L2527,739.8h-132.4c-29.8,0-54.9,17.3-66,44l-232.8,555.7h162.9l32.3-89.6h199.1L2508.8,1339.6z  M2335.7,1127.1l81.7-225.2l47,225.2H2335.7z M1682.9,739.8l-128.3,599.7h-155.1l128.3-599.7L1682.9,739.8L1682.9,739.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.a68cdcb817811884b644170ad6cb8905.svg";
export { ForwardRef as ReactComponent };